import gql from "graphql-tag";

import { Background } from "components/Background/Backgound";
import { Spinner } from "components/Spinner/Spinner";
import { ApiLogsDashboardUrl } from "generated/copilot-api-developer";
import { useQuery } from "graphql-client/useQuery";
import { useTranslation } from "i18n";

import { ApiLogs } from "../../../shared/Developers/ApiLogs/ApiLogs";
import { LookerDashboard } from "../Analytics/LookerDashboard";

gql`
  # schema = COPILOT_API_DEVELOPER
  query ApiLogsDashboardUrl {
    me {
      developer {
        apiLogsDashboardUrl
      }
    }
  }
`;

// TODO: The Looker embed is a temporary patch, to remove once the API logs page is rebuilt with our own UI.
// See https://app.notion.com/p/3fecb952371580ac9a0ef9d20583bc3f
export const ConsoleApiLogs = () => {
  const t = useTranslation();
  const { data, loading } = useQuery(ApiLogsDashboardUrl);

  if (loading) {
    return (
      <div className="flex-fill flex-center">
        <Spinner />
      </div>
    );
  }

  const dashboardUrl = data?.developer.apiLogsDashboardUrl;
  if (!dashboardUrl) return <ApiLogs />;

  return (
    <Background className="flex-col flex-fill overflow-hidden p-16 lg:p-44 space-y-24">
      <h1 className="text-primary-dark text-24 font-bold">
        {t("developers.api_logs.api_logs.api_logs")}
      </h1>
      <LookerDashboard analyticsDashboardUrl={dashboardUrl} />
    </Background>
  );
};
